<div class="me-2">
    <img src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1732604544778message-question.png"
        alt="icon " class="img img-fluid mx-4 mb-1" />
    <div class="text-secondary cursor-pointer">
        <small
            ngbTooltip="Need Help? Please click on need help to provide feedback,raise a support request or complaint"
            placement="bottom">
            <a (click)="openHelp(content)">Need Help?</a>
        </small>
    </div>


    <ng-template #content let-c="close" let-d="dismiss">
        <div class="modal-header">
            <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
        </div>
        
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title ms-5">Help and Support</h5>
               
            </div>
            <div class="modal-body">
                <aerp-base-schema-form [dataModel]="dataModel" [model]="model" [layout]="layout"
                    (onSubmitResponse)="onSubmitResponse($event)" [dataProcessor]="dataProcessor.bind(this)">
                </aerp-base-schema-form>
            </div>
        </div>
    </ng-template>
</div>